import React, { Component } from "react";
import EventIntro from "../Event/EventIntro";
import EventIntroCondensed from "../Event/EventIntroCondensed";
// import config from 'config/api';
// import LiveHelp from '../Lives/LiveHelp';
// import AvailableEvents from 'components/Event/AvailableEvents';
import EventSelector from "components/Event/EventSelector";
import HomeHelp from "components/Home/HomeHelp";
import BlockRatio from "components/BlockRatio";
import BlockButton from "components/UI/BlockButton";
import Immutable from "immutable";
import { withStyles } from "@material-ui/core/styles";
import EventCardBanner from 'components/Event/EventCardBanner';
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Avatar from "@material-ui/core/Avatar";
import clsx from "clsx";
import { withRouter } from "react-router-dom";
import { formatDate } from "helpers/stringUtils";
import RemainingTime from "components/UI/RemainingTime";
import Paragrapher from "components/UI/Paragrapher/Paragrapher";
import ThemeSelector from "components/Theme/ThemeSelector";
import getRemainingTime from "helpers/getRemainingTime";
import WarningIcon from "@material-ui/icons/Warning";
import config from "config/api";
import gotoLiveRoom from "helpers/gotoLiveRoom";
import getLiveEvent from "helpers/getLiveEvent";
import getMySubscriptions from "helpers/getMySubscriptions";
// import EventCardSimple from "components/Event/EventCardSimple";
import i18n from "helpers/i18n";

const styles = (theme) => {
  return {
    root: {
      maxWidth: "1280px",
      margin: "0 auto",
    },
    headerImage: {
      width: "100%",
      height: "100%",
      minHeight: 200,
      maxHeight: 400,
      maxWidth: 200,
    },
    headerImageWrapper: {
      padding: theme.spacing(0),
      [theme.breakpoints.down("sm")]: {
        padding: theme.spacing(2),
      },
    },
    headerContent: {
      [theme.breakpoints.down("sm")]: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        textAlign: "center",
      },
    },
    bgSpacerTop: {
      backgroundRepeat: "no-repeat",
      backgroundPosition: "50% 50%",
      backgroundSize: "cover",
      height: 138,
      backgroundImage: `url(${require("assets/images/" +
        process.env.REACT_APP_SITE +
        "/halfcircle_top.png")})`,
      marginBottom: theme.spacing(10),
      [theme.breakpoints.down("sm")]: {
        height: 70,
        marginBottom: theme.spacing(3),
      },
    },
    bgSpacerBottom: {
      backgroundRepeat: "no-repeat",
      backgroundPosition: "50% 50%",
      backgroundSize: "cover",
      backgroundImage: `url(${require("assets/images/" +
        process.env.REACT_APP_SITE +
        "/halfcircle.jpg")})`,
      // marginBottom: theme.spacing(10),
      [theme.breakpoints.down("sm")]: {
        height: 70,
        // marginBottom: theme.spacing(3)
      },
    },
    avatar: {
      width: "100%",
      height: "100%",
    },
    inline: {
      display: "inline-block",
    },
    emphasis: {
      color: theme.palette.secondary.main,
    },
    legend: {
      marginTop: 0,
      display: "inline",
      verticalAlign: "middle",
      fontSize: "24px",
    },
    legendButton: {
      display: "inline",
      verticalAlign: "middle",
      marginLeft: 20,
      backgroundColor: "transparent",
      backgroundImage: "none",
      boxShadow: "none",
      padding: 0,
      textTransform: "none",
      textDecoration: "underline",
      color: theme.palette.primary.main,
    },
    titleBig: {
      textAlign: "left",
      // [theme.breakpoints.down("md")]: {
      //   fontSize: "2rem",
      // },
      // [theme.breakpoints.down("sm")]: {
      //   fontSize: "1.5rem",
      //   textAlign: "center",
      // },
    },
    bg: {
      backgroundColor: "#f7f8fa",
    },
    buttonLegend: {
      fontSize: 14,
    },
    buttonLarge: {
      fontSize: 20,
      marginTop: 10,
    },
  };
};

const LIVE_ACTIVATION_DELAY = process.env.REACT_APP_SITE === "pneumo" ? 30 : 15;

class HomeVisitor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLiveButton: false,
    };
    this._runRemainingTimer = this._runRemainingTimer.bind(this);
    this._gotoLiveRoom = this._gotoLiveRoom.bind(this);
  }
  componentDidMount() {
    // console.log('START')
    this._startTimer();
  }
  componentDidUpdate(oldProps) {
    // console.log(oldProps.$$data.toJS(), oldProps.userRole, this.props.userRole)
    if (
      (oldProps.userRole === undefined && this.props.userRole !== undefined) ||
      (this.props.userRole !== undefined &&
        oldProps.$$data !== this.props.$$data)
    ) {
      // console.log('GOGOGO')
      this._startTimer();
    }
  }
  componentWillUnmount() {
    this._stopTimer();
  }
  _stopTimer() {
    if (this._remainingTimer) {
      clearInterval(this._remainingTimer);
    }
  }
  _startTimer() {
    // console.log('timer start')
    // const $$card = this._getCard();
    // console.log('test1')
    if (this._remainingTimer) return;
    const $liveEvent = this._getMyLiveEvent();
    // console.log('test2', $e)
    if ($liveEvent === undefined) return;

    // console.log('starting timer')
    // this._cardTimer = $$card.get('eventDate');
    this._remainingTimer = setInterval(this._runRemainingTimer, 1000);
    this._runRemainingTimer();
  }
  _runRemainingTimer() {
    // console.log('run1')
    const $liveEvent = this._getMyLiveEvent();
    // console.log('run2', $e)
    if ($liveEvent === undefined) {
      return this._stopTimer();
    }
    // console.log('run3')
    // console.log($liveEvent.toJS())
    // console.log($e)
    // console.log($e.get('eventState'))
    // const timeRemaining = $liveEvent !== undefined && $liveEvent.get('eventState') != 'live'
    const timeRemaining =
      $liveEvent !== undefined
        ? getRemainingTime($liveEvent.get("eventDate"))
        : {
            days: 0,
            hours: 0,
            minutes: 0,
          };
    // console.log(timeRemaining)
    if (
      timeRemaining.days <= 0 &&
      timeRemaining.hours <= 0 &&
      timeRemaining.minutes <= LIVE_ACTIVATION_DELAY
    ) {
      this.setState(
        {
          showLiveButton: true,
        },
        () => {
          // console.log('STOPPPING')
          this._stopTimer();
        }
      );
    } else {
      const { showLiveButton } = this.state;
      // console.log('RUN')
      this.setState({
        timeRemaining,
        showLiveButton: $liveEvent.get("eventState") === "live",
      });
    }
  }

  _goto = (url) => {
    const { history } = this.props;
    history.push(url);
  };
  _gotoLiveRoom = (e) => {
    const { $$user } = this.props;
    e.preventDefault();
    const $liveEvent = this._getMyLiveEvent();
    // gotoLiveRoom($liveEvent, (res) => {
      // if (res === true) this._goto("/live/" + $liveEvent.get("id"));
      this._goto("/live/" + $liveEvent.get("id"));
    // });
  };
  _getMyLiveEvent() {
    const { $$data, userRole } = this.props;
    const $$subscriptions = getMySubscriptions({ userRole, $$data });
    return getLiveEvent({ $$data, $$subscriptions });
  }
  _getMyPastEvent() {
    const { $$data } = this.props;
    if ($$data !== undefined) {
      // console.log($$data.toJS())
      // console.log($$subscriptions)
      // console.log($$data.get('myfutureevents'))
      // console.log($$data.get('mypastevents').filter($e => $e.get('hasAttended') !== undefined && $e.get('hasAttended') !== '' && $e.get('hasAttended') !== null).toJS())
    }
    return $$data !== undefined &&
      $$data.get("mypastevents") !== undefined &&
      $$data.get("mypastevents").size > 0
      ? $$data
          .get("mypastevents")
          .filter(
            ($e) =>
              $e.get("hasAttended") !== undefined &&
              $e.get("hasAttended") !== "" &&
              $e.get("hasAttended") !== null
          )
          .get(0)
      : undefined;
  }
  // _getMySubscriptions() {
  //   const {userRole, $$data} = this.props;
  //   const $$subscriptions = userRole !== undefined && $$data !== undefined && $$data.get('myfutureevents') !== undefined
  //   ? $$data.get('myfutureevents').sortBy(e => e.get('eventDate')).map(e => e.get('id'))
  //   : Immutable.Map();
  //   return $$subscriptions
  // }
  _onLiveStarted = () => {

  }
  render() {
    const {
      $$data,
      userRole,
      $$user,
      onSubscriptionComplete,
      classes,
    } = this.props;
    const { showLiveButton } = this.state;
    // const $$subscriptions = userRole !== undefined && $$data !== undefined && $$data.get('myfutureevents') !== undefined ? $$data.get('myfutureevents').map(e => e.get('id')) : Immutable.Map();
    const $$subscriptions = getMySubscriptions({ userRole, $$data });
    // console.log($$subscriptions.toJS())
    const $liveEvent = this._getMyLiveEvent();
    // console.log($e)
    // console.log($liveEvent.toJS())
    // const timeRemaining = $liveEvent !== undefined
    // ? getRemainingTime($liveEvent.get('eventDate'))
    // : {};
    const $pastEvent =
      $liveEvent === undefined ? this._getMyPastEvent() : undefined;

    let spacerBottomHeight;
    if (process.env.REACT_APP_SITE === "neonat") spacerBottomHeight = 37;
    else if (process.env.REACT_APP_SITE === "transplant")
      spacerBottomHeight = 78;
    else spacerBottomHeight = 138;
    return (
      <div className={clsx(classes.root)}>
        <Box>
        {/*  <If condition={$liveEvent !== undefined && showLiveButton === true}>
            <Box mt={3} mb={8} align="center">
              <Typography variant={"h3"} gutterBottom={true}>
                Live :
              </Typography>
              <Typography variant={"h5"} gutterBottom={true}>
                <Paragrapher
                  text={$liveEvent.get("eventTitle")}
                  prettyfy={true}
                />
              </Typography>
              <Button
                size={"large"}
                onClick={this._gotoLiveRoom}
                className={clsx(classes.buttonLarge)}
              >
                Accéder au live
              </Button>
            </Box>


          </If>*/}
          <If condition={$liveEvent !== undefined}>
          <EventCardBanner $$card={$liveEvent} userRole={userRole} $$subscriptions={$$subscriptions}  $$user={$$user} showRemainingTime={true} onLiveStarted={this._onLiveStarted} delay={LIVE_ACTIVATION_DELAY}/>
          </If>

          <If condition={$$data.get("availableEvents") === undefined}>
            <Typography variant={"h4"}>
              Pas d'émission pour l'instant...
            </Typography>
          </If>
          <If condition={$$data.get("availableEvents") !== undefined}>
            <Box align="center" bgcolor={"common.white"}>
              <ThemeSelector
                $$data={$$data}
                $$subscriptions={$$subscriptions}
              />

              <If condition={i18n.has("homeSingleParticipationWarning")}>
                <Box my={6} bgcolor={"common.white"} px={6}>
                  <Grid
                    container={true}
                    spacing={2}
                    alignItems="center"
                    justify="space-around"
                  >
                    <Grid item={true} xs={12} sm={1}>
                      <WarningIcon className={classes.inlineIcon} />
                    </Grid>
                    <Grid item={true} xs={12} sm={11}>
                      <Typography variant={"body2"}>
                        {i18n.get("homeSingleParticipationWarning", {
                          pretty: true,
                        })}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              </If>
            </Box>
          </If>
          <Box
            mt={5}
            className={classes.bgSpacerBottom}
            style={{
              height: spacerBottomHeight,
            }}
          ></Box>

          {/*  <If condition={($$subscriptions.size < 1 || $liveEvent === undefined) && $pastEvent === undefined}>
            <Box className={classes.bgSpacer}></Box>

            <Box align="center" mb={8} px={6}>

            <Typography variant={'body2'}>
            La téléconsultation peut vous exposer à un risque médico-juridique et voir les plaintes de la part des patients augmenter (non respect du secret médical, devoir d'information du patient, consentement libre et éclairé, conservations des données...). En 45 minutes, un avocat spécialisé en droit de la santé fera le point avec vous sur le cadre juridique et les règles à respecter pour mettre en place sereinement la téléconsultation. Il apportera un éclairage précis sur les nouvelles règles de la téléconsultation en cette période de crise sanitaire. [b]Il répondra en direct à toutes vos questions[/b]
            </Typography>
            </Box>
            </If>*/}
          <Box className={classes.bg}>
            <HomeHelp />

            <Box align="center" mt={16} mb={8} px={4}>
              <Typography variant={"h4"}>
                {i18n.get("homeText1", { prettyfy: false })}

                <br />
                <strong className={clsx(classes.inline, classes.emphasis)}>
                  {i18n.get("homeText2", { prettyfy: false })}
                </strong>
              </Typography>
            </Box>
            <Box align="center" mb={10}>
              <Avatar
                style={{
                  height: 124,
                  width: 124,
                  marginBottom: 30,
                }}
                src={require("assets/images/" +
                  process.env.REACT_APP_SITE +
                  "/icons/link.svg")}
              ></Avatar>
              <Typography variant={"subtitle2"} color="secondary">
                {i18n.get("homeText3", { prettyfy: false })}
              </Typography>
            </Box>

            <Box align="center" mb={12} px={4}>
              <EventIntro $$data={$$data.get("intro")} />
            </Box>
          </Box>
        </Box>
      </div>
    );
  }
}

export default withRouter(withStyles(styles)(HomeVisitor));



// WEBPACK FOOTER //
// ./src/components/Home/HomeVisitor.jsx